module.exports = __webpack_public_path__ + "static/media/allCAEX.bfd26c09.svg";